import { Chart, DataGrid, SelectBox } from "devextreme-react";
import { useState } from "react";
import { paletteData } from "../data";
import { handleCellStyle } from "../utils";
import {
  Column,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Scrolling,
} from "devextreme-react/data-grid";
import {
  ArgumentAxis,
  CommonSeriesSettings,
  Export,
  Label,
  Legend,
  Series,
  Title,
  Tooltip,
  ValueAxis,
} from "devextreme-react/chart";
import styled from "styled-components";

const EnrollStatusViewerWrapper = styled.div`
  margin: 0 20px;
  > div {
    margin-bottom: 16px;
  }
  tbody {
    td {
      table {
        width: 100%;
        table-layout: fixed;
        word-break: break-all;
        height: auto;
        td {
          background-color: #fafafa;
          padding: 8px 16px;
          p {
            margin: 0;
          }
        }
        tr:nth-child(2n) {
          td {
            background-color: white;
          }
        }
      }
      img {
        /* display: block; */
        /* width: 100%; */
        max-width: 100%;
        height: auto;
      }
    }
  }
`;

const TooltipWrapper = styled.div`
  h3 {
    margin: 0;
    margin-bottom: 8px;
    border-bottom: 1px solid gray;
    font-size: 1.4em;
  }
  h3 + div {
    display: grid;
    grid-template-columns: 170px auto;
    grid-template-rows: repeat(auto-fill, auto);
    color: #e6e6e6;
    font-size: 1.2em;
    line-height: 150%;
    > div:nth-child(2n) {
      text-align: right;
    }
  }
`;

const EnrollStatusViewer = ({ chartRef, memoRef, contrNo }) => {
  const [palette, setPalette] = useState(
    window.localStorage.getItem("MonthlyReport.Palette") || "Ocean"
  );

  const handlePaletteChange = (e) => {
    window.localStorage.setItem("MonthlyReport.Palette", e.value);
    setPalette(e.value);
  };

  const renderTooltip = (e) => {
    const targetPoint = e.points.find(
      (el) => el.seriesName === "Current Month Enrolled"
    );

    if (!targetPoint) return;

    const {
      argument: yearMonth,
      value: newSubject,
      total: totalSubject,
    } = targetPoint;

    return (
      <TooltipWrapper>
        <h3>{yearMonth}</h3>
        <div>
          <div>Current Month Enrolled:</div>
          <div>{newSubject}례</div>
          <div>Total Enrolled Subject:</div>
          <div>{totalSubject}례</div>
        </div>
      </TooltipWrapper>
    );
  };

  return (
    <EnrollStatusViewerWrapper>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <span style={{ marginRight: "8px" }}>Palette</span>
        <SelectBox
          dataSource={paletteData}
          defaultValue={palette}
          onValueChanged={handlePaletteChange}
        />
      </div>
      <div>
        <Chart palette={palette} ref={chartRef}>
          <Title
            font={{ weight: 600 }}
            horizontalAlignment="center"
            text={`Monthly Accumulated Number of Subject Status (${contrNo.trim()})`}
          />
          <CommonSeriesSettings argumentField="yearMonth">
            <Label font={{ size: "1em" }} visible={true} />
          </CommonSeriesSettings>
          <Series
            name="Previous Month Enrolled (Accu.)"
            valueField="accum"
            axis="count"
            type="stackedbar"
          />
          <Series
            name="Current Month Enrolled"
            valueField="curr"
            axis="count"
            type="stackedbar"
          />
          <Series
            name="Target Enrolled Subject"
            valueField="target"
            axis="count"
            type="spline"
          />
          <ArgumentAxis>
            <Label overlappingBehavior="rotate" />
            <Title
              alignment="right"
              font={{ size: "1em", weight: 600 }}
              text="Year-Month"
            />
          </ArgumentAxis>
          <ValueAxis name="count" position="left">
            <Label visible={false} />
            <Title
              alignment="right"
              font={{ size: "1em", weight: 600 }}
              text="Total Enrolled Subject"
            />
          </ValueAxis>
          <Tooltip
            enabled={true}
            location="edge"
            shared={true}
            contentRender={renderTooltip}
            zIndex={10000}
          />
          <Legend
            font={{ size: "1em", weight: 600 }}
            horizontalAlignment="center"
            verticalAlignment="bottom"
          />
          <Export enabled={true} />
        </Chart>
      </div>
      <div>
        <DataGrid
          allowColumnResizing={true}
          columnResizingMode={"nextColumn"}
          height={400}
          id="monthlyEnrollStatusMemo"
          onCellPrepared={handleCellStyle}
          ref={memoRef}
          showBorders={true}
          showColumnLines={true}
          width={"100%"}
          wordWrapEnabled={true}
        >
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <LoadPanel enabled={true} />
          <Scrolling mode="virtual" showScrollbar={"always"} />
          <Column
            dataField="yearMonth"
            alignment="center"
            caption="Year-Month"
            width={200}
          />
          <Column
            dataField="descr"
            alignment="left"
            caption="Description"
            encodeHtml={false}
          />
        </DataGrid>
      </div>
    </EnrollStatusViewerWrapper>
  );
};

export default EnrollStatusViewer;
